/** @jsx jsx */
import React from 'react'
import { jsx, } from 'theme-ui'
import { Themed } from "@theme-ui/mdx"
import scrollTo from 'gatsby-plugin-smoothscroll'
import SocialMediaList from './social-media-list'

const MenuList = () => {
  const topMenu = [{ title: 'about', href: '#about' }, { title: 'contact', href: '#contact'}]
  return (
    <React.Fragment>
      {topMenu.map((entry) => (
        <Themed.a key={entry.title} onClick={() => scrollTo(entry.href)}>
          {entry.icon ? entry.icon : entry.title}
        </Themed.a>
      ))}
      <SocialMediaList />
    </React.Fragment>
  )
}

export default MenuList
